/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequest
 */
export interface CreateReservationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    diners: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReservationRequest
     */
    tables?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    customerComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    zone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the CreateReservationRequest interface.
 */
export function instanceOfCreateReservationRequest(value: object): value is CreateReservationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    return true;
}

export function CreateReservationRequestFromJSON(json: any): CreateReservationRequest {
    return CreateReservationRequestFromJSONTyped(json, false);
}

export function CreateReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'phoneNumber': json['phoneNumber'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'tables': json['tables'] == null ? undefined : json['tables'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function CreateReservationRequestToJSON(json: any): CreateReservationRequest {
    return CreateReservationRequestToJSONTyped(json, false);
}

export function CreateReservationRequestToJSONTyped(value?: CreateReservationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'tables': value['tables'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'email': value['email'],
    };
}

